import React from 'react';
import logo from './logo.png';
import './App.css';

import Home from './pages/home'

import _ from 'underscore'

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

// Usage
export default class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }
  
  render() {

    return (
      <Router>
      <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <div>
          AI Chest X-ray Radiology Assistant (Myanmar)
        </div>
      </header>
        {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
      <Switch>
        <Route path="/">
          <Home />
        </Route>
      </Switch>
      <div className="App-footer">
        <div style={{fontSize: 14}}> &copy; 2020 <i>AI Chest X-ray Radiology Assistant (Myanmar) (Research and Education Purpose)</i>
        {/* <a href="https://learn-ai.co" target="blank" style={{textDecoration: 'none', color: '#f2e93b'}}><i>Learn.AI (Myanmar)</i></a> */}
        </div>
        <div style={{color: 'red', fontSize: 14}}> *** (Radiologist only) ***</div>
      </div>
      </div>
    </Router>
    )
  }
}